import { RobotoLink } from "@/shared/components";
import { useDataset } from "@/shared/domain/datasets/hooks";
import { FileRecord } from "@/shared/domain/files";
import { dirname } from "@/shared/domain/files/filesystem";

interface FileParentAssociation {
  /** The current file record */
  fileRecord: FileRecord;
}

/**
 * UI for displaying what dataset the file belongs to
 */
export function FileParentAssociation({ fileRecord }: FileParentAssociation) {
  const datasetId = fileRecord.association_id;
  const datasetQuery = useDataset(datasetId);
  const dataset = datasetQuery.data;

  return (
    <RobotoLink
      to={`/datasets/${datasetId}/${dirname(fileRecord.relative_path)}`}
    >
      {dataset?.name ? `${datasetId} (${dataset.name})` : datasetId}
    </RobotoLink>
  );
}
